export const HEARTBEAT = 'HEARTBEAT';
export const GHOSTWRITER = 'GHOSTWRITER';
export const PLATFORM = 'PLATFORM';
export const ASSETS = 'ASSETS';
export const SETTINGS = 'SETTINGS';

const allModules = { HEARTBEAT, GHOSTWRITER, PLATFORM, ASSETS, SETTINGS };

export default allModules;
